import "./login.css";
import { useNavigate } from "react-router-dom";
import { AiOutlineLogin } from "react-icons/ai";
import { decodeToken } from "react-jwt";

const LogIn = ({ setAuthenticated, setUser, authTimeout, setAuthTimeout }) => {
  const navigate = useNavigate();

  const authenticate = (e) => {
    e.preventDefault();
    clearTimeout(authTimeout)

    let username = document.getElementById("loginUsername").value;
    let password = document.getElementById("loginPassword").value;

    if (username !== "" && password !== "") {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        username: username,
        password: password,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${process.env.REACT_APP_API_URL}/login`, requestOptions)
        .then((response) => {
          if (response.status!==200) {
            throw new Error("API response was not ok");
          }
          return response.text();
        })
        .then((result) => {
          const userObject = JSON.parse(result);

          if (userObject.token) {
            let decodedToken = decodeToken(userObject.token);
            if (!decodedToken || !decodedToken.exp) {
              console.error("Invalid JWT format or missing expiration time");
            } else {
              const expirationTime = decodedToken.exp * 1000;
              const currentTime = new Date().getTime();
              const timeRemaining = expirationTime - currentTime;
              setAuthTimeout(setTimeout(() => {
                window.location.href = "/login"
              }, timeRemaining))
            }
            localStorage.setItem("token", userObject.token);
            setAuthenticated(true);
            setUser(userObject)
            window.location.href = "/wyceny"
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
          alert("Wystąpił problem z autoryzacją, proszę spróbować później.");
        });
    }
  };

  return (
    <div className="login-form-wrapper">
      <form className="login-form" id="login-form">
          <AiOutlineLogin
            size={100}
            style={{ fill: "var(--psblue)", marginBottom: "30px" }}
          />
        <label for="username">
          <b>NAZWA UŻYTKOWNIKA</b>
        </label>
        <input
          type="text"
          placeholder="Proszę wpisać nazwę użytkownika..."
          name="username"
          id="loginUsername"
          required
        />

        <label for="password">
          <b>HASŁO</b>
        </label>
        <input
          type="password"
          placeholder="Proszę wpisać hasło..."
          name="password"
          id="loginPassword"
          required
        />

        <button
          type="submit"
          onClick={(e) => authenticate(e)}
        >
          LOGIN
        </button>
      </form>
    </div>
  );
};

export default LogIn;
